<ng-container *transloco="let t; prefix: 'payment.wizard.stepTwo'">
    <!-- Header -->
    <div class="flex flex-col w-full gap-2 items-center justify-center">
        <h2 class="rfs:text-[40px] text-center font-semibold text-black">
            {{t('header')}}
        </h2>
        <p class="rfs:text-xl text-center font-light text-tone-09">
            {{t('infoText')}}
        </p>
    </div>
    <!-- END OF Header -->

    <!-- Select entry Button group by category -->
    <div class="flex justify-center w-full max-w-[800px]">
        <app-tab-pill-group-button class="flex-1" [items]="tabPillGroupButtons"
            [alwaysShowPill]="true"
            (itemSelected)="handleButtonGroupItemSelected($event)" />
    </div>
    <!-- END OF Select entry Button group by category -->

    <!-- Input value based on the selected type -->
    @if (this.caseItem === 'receipt') {
    <div class="flex flex-wrap w-full max-w-[800px] md:gap-8 gap-6">
        <div class="flex flex-1 md:min-w-[45%] w-full flex-col gap-2 group/input">
            <label
                class="flex items-center gap-2 text-gray-950 font-semibold text-tone-09 group-disabled:text-tone-04">{{t('label')}}
                <span class="text-error">*</span>
            </label>
            <input formControlName="name"
                class="text-tone-09 rounded-full border border-tone-05 py-3 px-4 group-hover/input:bg-tone-01 group-focus-within/input:border-[1.5px] group-focus-within/input:border-tone-07 tranistion-colors duration-300 outline-none">
        </div>
        <div class="flex flex-1 md:min-w-[45%] w-full flex-col gap-2 group/input">
            <label
                class="flex items-center gap-2 text-gray-950 font-semibold text-tone-09 group-disabled:text-tone-04">{{t('label')}}
                <span class="text-error">*</span>
            </label>
            <input formControlName="name"
                class="text-tone-09 rounded-full border border-tone-05 py-3 px-4 group-hover/input:bg-tone-01 group-focus-within/input:border-[1.5px] group-focus-within/input:border-tone-07 tranistion-colors duration-300 outline-none">
        </div>
        <div class="flex flex-1 md:min-w-[45%] w-full flex-col gap-2 group/input">
            <label
                class="flex items-center gap-2 text-gray-950 font-semibold text-tone-09 group-disabled:text-tone-04">{{t('label')}}
                <span class="text-error">*</span>
            </label>
            <input formControlName="name"
                class="text-tone-09 rounded-full border border-tone-05 py-3 px-4 group-hover/input:bg-tone-01 group-focus-within/input:border-[1.5px] group-focus-within/input:border-tone-07 tranistion-colors duration-300 outline-none">
        </div>
        <div class="flex flex-1 md:min-w-[45%] w-full flex-col gap-2 group/input">
            <label
                class="flex items-center gap-2 text-gray-950 font-semibold text-tone-09 group-disabled:text-tone-04">{{t('label')}}
                <span class="text-error">*</span>
            </label>
            <input formControlName="name"
                class="text-tone-09 rounded-full border border-tone-05 py-3 px-4 group-hover/input:bg-tone-01 group-focus-within/input:border-[1.5px] group-focus-within/input:border-tone-07 tranistion-colors duration-300 outline-none">
        </div>
    </div>
    } @else if (this.caseItem === 'invoice') {

    }
    <!-- END OF Input value based on the selected type -->
</ng-container>